import countries from "i18n-iso-countries";
import enCountries from "i18n-iso-countries/langs/en.json";
import moment from "moment";

countries.registerLocale(enCountries);

const countryFromTimezone = timezone => {
  let countryCode = null;

  for (let country of moment.tz.countries()) {
    const isZone = moment.tz
      .zonesForCountry(country)
      .find(zone => zone === timezone);
    if (isZone) {
      countryCode = country;
      break;
    }
  }

  for (let [key, value] of Object.entries(countries.getNames("en"))) {
    if (key === countryCode) {
      return { key, value };
    }
  }
};

const timezonesForCountry = country => {
  return country ? moment.tz.zonesForCountry(country.key) : [];
};

export default {
  name: "TimezoneSelector",

  props: ["errors", "defaultTimezone"],

  data() {
    return {
      country: null,
      countries: Object.entries(countries.getNames("en")).map(
        ([key, value]) => {
          return { key, value };
        }
      ),
      timezone: null,
      timezones: []
    };
  },
  methods: {
    refreshTimezones() {
      this.timezones = timezonesForCountry({ key: this.country });
      this.timezone = this.timezones.length > 0 ? this.timezones[0] : null;
      this.timezoneSelected();
    },
    timezoneSelected() {
      this.$emit("timezoneSelected", { 
        timezone: this.timezone,
        // for some reason, some timezones gives back an object for country
        country: typeof this.country == 'object' 
          ? this.country['key'] && this.country['key']
          : this.country && this.country
      });
    }
  },
  created() {
    this.country = countryFromTimezone(this.defaultTimezone);
    this.timezones = timezonesForCountry(this.country);
    this.timezone = this.defaultTimezone;
  },
  watch: {
    defaultTimezone() {
      this.country = countryFromTimezone(this.defaultTimezone);
      this.timezones = timezonesForCountry(this.country);
      this.timezone = this.defaultTimezone;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/_timezone-selector/timezone-selector.js